// crewbit-admin/src/lib/aging.ts
//
// Pure aging-bucket helpers per MONEY_MODULE_SPEC_v1.md §Outstanding.7.3.
// Mirrors crewbit-mobile/lib/aging.ts.

export type AgingBucket = 'current' | '1_30' | '31_60' | '61_plus';

export function bucketForDays(days: number): AgingBucket {
  if (days <= 0) return 'current';
  if (days <= 30) return '1_30';
  if (days <= 60) return '31_60';
  return '61_plus';
}

export function bucketTone(bucket: AgingBucket): 'neutral' | 'warning' | 'danger' {
  switch (bucket) {
    case 'current': return 'neutral';
    case '1_30':    return 'neutral';
    case '31_60':   return 'warning';
    case '61_plus': return 'danger';
  }
}
